module.exports = __webpack_public_path__ + "079baa14264184c2ea9972f33e53b0fb.pdf";